import * as React from 'react';
import { Dialog, AppBar, Toolbar, Typography, Box, Slide, styled, useTheme, MenuItem, Divider, Avatar, Tooltip } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import MerLionHeader from 'components/MerLionHeader';
import Logo from 'assets/images/imda-full-logo.svg';

// import ImdaButton from 'components/button';
import { useNavigate } from 'react-router-dom';
import { LOGIN_TEXT, APP_TEXT, DB_TEXT, LOGOUT_TEXT } from 'common/constants';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';

import IconButton from '@mui/material/IconButton';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useSelector } from 'store';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SearchBar from 'components/searchbar';

type Props = {
    isUserLogged: boolean;
    id?: string;
    handleLogin: () => void;
    userId?: string;
    userUen?: string;
};

const StyledTypography = styled(Typography)({
    margin: 'auto'
});

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function MobileMenu({ isUserLogged, id, handleLogin, userId, userUen }: Props) {
    const theme = useTheme();
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);
    const { user } = useSelector((state) => state.account);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const StyledImg = styled('img')(({ theme }) => ({
        height: '46px',
        cursor: 'pointer',
        [theme.breakpoints.down('sm')]: {
            height: '30px'
        }
    }));

    return (
        <Box sx={{ marginLeft: '10px' }}>
            <Box id={id} sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' }, justifyContent: 'flex-end' }}>
                {isUserLogged && (
                    <Box
                        sx={{
                            '&:hover': {
                                cursor: 'pointer'
                            },
                            display: { xs: 'none', sm: 'flex' },
                            alignItems: 'center'
                        }}
                        onClick={() => navigate('/my-applications')}
                    >
                        <StyledTypography>{user?.role === 'singpass' ? userId : userUen}</StyledTypography>
                        <Avatar
                            variant="rounded"
                            sx={{
                                transition: 'all .2s ease-in-out',
                                background: 'transparent',
                                color: theme.palette.primary.dark
                            }}
                            id="profile-button"
                        >
                            <AccountCircleIcon />
                        </Avatar>
                    </Box>
                )}
                <IconButton
                    data-testid="menu-bar"
                    id="menu-bar"
                    size="large"
                    aria-haspopup="true"
                    onClick={handleClickOpen}
                    color="inherit"
                    aria-label="Open Menu"
                >
                    <MenuRoundedIcon sx={{ fontSize: '2.5rem', color: theme.palette.primary.dark }} />
                </IconButton>
            </Box>
            <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition} sx={{ '& .MuiPaper-root': { p: 0 } }}>
                <AppBar elevation={1} sx={{ position: 'relative', backgroundColor: 'transparent' }}>
                    <MerLionHeader />
                    <Toolbar sx={{ p: '10px 15px' }}>
                        <Typography component="div" sx={{ textAlign: 'left', flexGrow: 1 }}>
                            <StyledImg src={Logo} onClick={() => navigate('/')} />
                        </Typography>
                        <IconButton
                            edge="start"
                            color="primary"
                            onClick={handleClose}
                            aria-label="close"
                            test-dataid="menu-close-btn"
                            id="menu-close-btn"
                            sx={{ '& svg': { fontSize: '40px' }, p: 0 }}
                        >
                            <CloseRoundedIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Box sx={{ p: { xs: '16px', sm: '24px 16px', md: '48px 16px' } }}>
                    <MenuItem data-testid="app-bar-menu-search" sx={{ p: 0 }}>
                        <SearchBar />
                    </MenuItem>
                    <MenuItem data-testid="app-bar-menu-applications" onClick={() => navigate('/applications')} sx={{ p: 0 }}>
                        {APP_TEXT}
                    </MenuItem>
                    <Divider />
                    <MenuItem data-testid="app-bar-menu-guide" onClick={() => navigate('/guides')} sx={{ p: 0 }}>
                        Guides
                    </MenuItem>
                    <Divider />
                    <MenuItem data-testid="app-bar-menu-databases" onClick={() => navigate('/databases')} sx={{ p: 0 }}>
                        {DB_TEXT}
                    </MenuItem>
                    <Divider />
                    {isUserLogged && (
                        <MenuItem data-testid="app-bar-menu-my-applications" onClick={() => navigate('/my-applications')} sx={{ p: 0 }}>
                            My Dashboard
                        </MenuItem>
                    )}
                    <Divider />
                    <MenuItem
                        data-testid={isUserLogged ? 'menu-logout-button' : 'menu-login-button'}
                        id={isUserLogged ? 'logout-button' : 'login-button'}
                        sx={{ color: theme.palette.primary.dark, p: 0 }}
                        onClick={handleLogin}
                    >
                        {isUserLogged ? LOGOUT_TEXT : LOGIN_TEXT}
                    </MenuItem>
                </Box>
            </Dialog>
        </Box>
    );
}

export default MobileMenu;
